import logout from 'user/logout';
import Domain from 'helpers/Domain';

export default class {
    // Disconnect from authsuite then logout
    async logoutWithAuthSuite(authorizationService, onSuccess) {
        await authorizationService.disconnectDevice(true);

        logout(onSuccess);
    }
    logout(onSuccess) {
        logout(onSuccess);
    }
}
